import { defineStore } from 'pinia';
import { useNuxtApp } from 'nuxt/app';
import { ref, type Ref } from 'vue';
import ObjectCache from '~~/common/utils/ObjectCache';
import otqs from '~~/common/utils/objectToQueryString';
import type { Schema } from '~~/common/types/api';

//todo use backend API types after backend API swagger is updated with the correct types
// be documents GET /api/v2/faq-list as a bare `FaqModel[]`, but it actually returns an array of
// groups (`{id, orderIndex, name, locale, petrol, faqs}`). The nested `faqs` items do match
// `FaqModel`. Verified against the dev API (`isPetrol=0` and `isPetrol=1`).
export interface FaqGroup {
  id: number;
  orderIndex: number;
  name: string;
  locale: string;
  petrol: boolean;
  faqs: Schema<'FaqModel'>[];
}

const faqCache = new ObjectCache<Promise<FaqGroup[]>>('faq', '__');
export const useFaqsStore = defineStore('faqs', () => {
  const nuxtApp = useNuxtApp();
  const items: Ref<FaqGroup[]> = ref([]);

  async function fetchFaqs (options?: { isPetrol?: boolean; isLoyaltyProgram?: boolean }) {
    const {
      $api,
      $logger,
      $i18n,
    } = nuxtApp;
    const cacheKey: string[] = ['faq', $i18n.locale.value, options?.isPetrol?.toString(), options?.isLoyaltyProgram?.toString()].filter(item => item != undefined);

    const params = {
      categoryId: 1,
      page: 1,
      isPetrol: options?.isPetrol ? 1 : 0,
      isLoyaltyProgram: options?.isLoyaltyProgram ? 1 : 0,
    };

    faqCache.initCache(cacheKey, () => $api.$get<FaqGroup[]>(`faq-list${otqs(params)}`));
    const result = await faqCache.getCache(cacheKey)?.value?.catch((err) => {
      $logger.error(err);
      return [];
    });
    const resultArray = Object.values(result || []);
    items.value = await [...resultArray].sort((a, b) => (a.orderIndex > b.orderIndex) ? 1 : -1);
  }

  return {
    items,
    fetchFaqs,
  };
});
